import { Button as MaterialButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const TextButton = styled(MaterialButton)({
  boxShadow: 'none',
  fontFamily: 'Geist Sans, Inter, Sans-serif',
  textTransform: 'none',
  fontSize: '12px',
  backgroundColor: 'none',
  borderColor: 'none',
  color: 'var(--primary-color)',
  fontWeight: 500,
  outline: 'none',
  '&:hover': {
    fontWeight: 600,
    borderColor: 'none',
    boxShadow: 'none',
    background: 'none'
  },
  '&:active': {
    boxShadow: 'none',
  },
  '&:disabled': {
    opacity: 0.99,
    color: "var(--text-secondary)"
  }
});

const Button = styled(MaterialButton)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '12px',
  backgroundColor: 'var(--background-primary)',
  borderColor: 'var(--borderColor)',
  color: 'var(--text-primary)',
  fontWeight: 'normal',
  '&:hover': {
    backgroundColor: 'var(--hover-bg)',
    borderColor: 'var(--borderColor)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
  },
});

const DeleteButton = styled(MaterialButton)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '12px',
  backgroundColor: 'rgb(211, 47, 47)',
  borderColor: 'rgb(211, 47, 47)',
  borderRadius: '6px',
  color: "var(--text-primary)",
  fontWeight: 'normal',
  padding: '4px 14px',
  '&:hover': {
    backgroundColor: 'rgb(211, 47, 47)',
    borderColor: 'rgb(211, 47, 47)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
  },
});

const SecondaryButton = styled(MaterialButton)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '12px',
  backgroundColor: "var(--background-primary)",
  borderColor: "var(--borderColor)",
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: '6px',
  color: 'var(--text-primary)',
  fontWeight: 'normal',
  padding: '4px 14px',
  '&:hover': {
    backgroundColor: "var(--hover-bg)",
    borderColor: "var(--borderColor)",
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
  },
});

const CustomButton = (props) => {
  return <Button {...props} />;
};

const LabelButton = (props) => {
  return <TextButton {...props} />
}

export { DeleteButton, SecondaryButton, LabelButton };
export default CustomButton;
